import { PencomGenericBanner } from "@/components/banners/PencomBanner";
import { PrimaryButton } from "@/components/buttons/PrimaryButton";
import { PencomBackButton } from "@/components/layout/PencomBackButton";
import { PencomRoutes } from "@/router";
import { useNavigate } from "react-router-dom";
export const EmployerRepRegistrationSuccessPage = () => {
    const navigate = useNavigate();

    const handleLogin = () => {
        navigate(PencomRoutes.LOGIN)
    }
    return (
        <div className="w-full flex flex-col min-h-screen">
            <PencomBackButton title="Back" />
            <div className="w-full flex flex-col items-center justify-center  max-w-[460px] mx-auto mt-[80px]">
                <img src="/assets/icons/solid-check.svg" className="w-10 h-10" alt="check-circle" />
                <h2 className="mt-4 font-clash-display text-2xl font-semibold text-medium-dark-grey">Employer Code Generated</h2>
                <p className="mt-8 font-clash-display text-sm font-regular text-medium-dark-grey">Your unique employer code for TechCorp Nigeria Ltd.</p>
                <div className="border mt-4 w-full bg-white flex items-center flex-row justify-between border-stroke rounded-lg p-4">
                    <div className="flex-col flex-1">
                        <p className="font-clash-display text-center text-sm font-regular text-medium-dark-grey">Employer Code</p>
                        <div className="flex justify-center flex-row items-center">
                            <p className="font-clash-display text-2xl font-semibold text-medium-dark-grey">1234567890</p>
                        </div>
                    </div>
                    <div className="cursor-pointer flex justify-end mt-5 items-center gap-x-1">
                        <img src="/assets/icons/copy-bold.svg" className="w-4 h-4" alt="copy" />
                        <p className="font-clash-display text-sm font-semibold text-medium-grey">Copy</p>
                    </div>
                </div>
                <PrimaryButton className="w-full mt-10" title="Go to Login" onClick={handleLogin} />
                <PencomGenericBanner title="For Future References" className="mt-6">
                    <span className="font-clash-display text-sm font-regular text-medium-dark-grey">
                        Your employer code has also been sent to your registered company email <span className="font-medium text-sm font-clash-display text-medium-dark-grey">info@techcorp.com.</span>
                    </span>
                </PencomGenericBanner>
            </div>
        </div>
    );
};